export const SET_EXPAND_LEX_STATE = 'SET_EXPAND_LEX_STATE';

export const SET_EXPAND_INDEX = 'SET_EXPAND_INDEX';

export const SET_BLOCK_EXPAND = 'SET_BLOCK_EXPAND';

export const SET_TRACKING_STATE = 'SET_TRACKING_STATE';

export const SET_LOGIN_MODAL = 'SET_LOGIN_MODAL';
